import { Environment } from '@abp/ng.core';

const baseUrl = 'https://returnly-dev-app.wegotnerds.com';

const oAuthConfig = {
  issuer: 'https://account.returnly-dev-api.wegotnerds.com/',
  redirectUri: baseUrl,
  clientId: 'ReturnLy_App',
  responseType: 'code',
  scope: 'offline_access ReturnLy',
  requireHttps: true,
};

export const environment = {
  production: false,
  homeUrl: 'https://return-ly.webflow.io/',
  application: {
    baseUrl,
    name: 'ReturnLy',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://account.returnly-dev-api.wegotnerds.com',
      rootNamespace: 'ReturnLy',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  remoteEnv: {
    url: '/getEnvConfig',
    mergeStrategy: 'deepmerge'
  }
} as Environment;
